import { render, staticRenderFns } from "./IconB.vue?vue&type=template&id=d340eb32&"
import script from "./IconB.vue?vue&type=script&lang=js&"
export * from "./IconB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports